export const DEFAULT_QUERY_STALE_TIME = 5 * 60 * 1000; // 5 minutes
